import еventsCompetitionsSearch from '@/store/modules/еvents-сompetitions-search/еvents-сompetitions-search'

export default {
  еventsCompetitionsSearch,
}
